import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import Technology from "./Technology";
import Action from "./Action";
import laptopImg from "../../Assets/about.png";
import Toolstack from "./Toolstack";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              我的<strong className="purple">技术栈</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "100px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src={laptopImg} alt="about" className="img-fluid" />
          </Col>
        </Row>
        <h1 className="project-heading">
           <strong className="purple">后期制作</strong>软件
        </h1>
        <Techstack />

        <h1 className="project-heading">
          <strong className="purple">AI</strong>工具
        </h1>
        <Toolstack />

        <h1 className="project-heading">
          <strong className="purple">其他技术</strong>及<strong className="purple">工具</strong> 
        </h1>
        <Technology />

        <h1 className="project-heading">
          拍摄<strong className="purple">设备</strong> 
        </h1>
        <Action />

        <Github />
      </Container>
    </Container>
  );
}

export default About;

